import useSearchFriends from '@/hooks/search/use-search-friends';
import useSearchGroup from '@/hooks/search/use-search-group';
import useSearchGroupMembers from '@/hooks/search/use-search-group-members';
import useSearchMessages from '@/hooks/search/use-search-messages';

export default function useGlobalSearch(keyword = '') {
  const { messages, isLoading: isLoadingMessages } = useSearchMessages(keyword);
  const { groupMembers, isLoading: isLoadingUsers } = useSearchGroupMembers(keyword);
  const { filteredGroups, isLoading: isLoadingGroups } = useSearchGroup(keyword);
  const { filteredFriends, isLoading: isLoadingFriends } = useSearchFriends(keyword, {
    searchIncludeTags: true,
    initialReturnAll: false,
  });

  const isLoading = isLoadingMessages || isLoadingUsers || isLoadingFriends || isLoadingGroups;

  return {
    messages,
    groupMembers,
    groups: filteredGroups,
    friends: filteredFriends,
    isLoading,
  };
}

export type GlobalSearchReducerActionType = 'all' | 'messages' | 'groups' | 'friends';
